import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import {
  selectCurrentEventCode,
  selectCurrentEventId,
  selectHasJoinedEvent,
  selectIsEventManager,
} from "modules/event/selectors";
import useEventStatus from "../../hooks/useEventStatus";

const EventStatusSubscriber = () => {
  const currentEventId = useSelector(selectCurrentEventId);
  const hasJoinedEvent = useSelector(selectHasJoinedEvent);
  const currentEventCode = useSelector(selectCurrentEventCode);
  const hasEventManagerAccess = useSelector(selectIsEventManager);
  const eventStatus = useEventStatus();
  const history = useHistory();

  useEffect(() => {
    if (!currentEventId || !hasJoinedEvent) {
      return;
    }
    eventStatus.subscribe(currentEventId, (status: string) => {
      if (
        currentEventCode &&
        (status === "inactive" || status === "archived") &&
        !hasEventManagerAccess
      ) {
        history.push(`/e/${currentEventCode}/register?action=EVENT_ENDED`);
      }
    });

    // eslint-disable-next-line consistent-return
    return () => {
      eventStatus.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEventId, currentEventCode, hasJoinedEvent]);

  return null;
};

export default EventStatusSubscriber;
